import BrandsCarousel from "./BrandsCarousel";
import ProjectGallery from "./ProjectGallery";
import Hero from "./Hero";
import AboutPreview from "./AboutPreview";

function Home() {
  return (
    <div className="home">
      <Hero />
      <BrandsCarousel />
      <ProjectGallery />
      <AboutPreview/>
    </div>
  );
}

export default Home;
